import { useTranslation } from 'react-i18next';
import { PublicLayout } from '@/components/layout';

const Cookies = () => {
  const { t } = useTranslation();

  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-dark-800 dark:text-white mb-8">
          {t('cookiesPage.title')}
        </h1>

        <div className="prose prose-gray max-w-none space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('cookiesPage.whatTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.whatText')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('cookiesPage.typesTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.typesDescription')}
            </p>

            <h3 className="text-lg font-medium text-dark-800 dark:text-white mt-4 mb-2">{t('cookiesPage.necessaryTitle')}</h3>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.necessaryText')}
            </p>
            <div className="overflow-x-auto mt-3">
              <table className="min-w-full text-sm text-gray-600 dark:text-gray-300">
                <thead>
                  <tr className="border-b border-gray-200 dark:border-dark-700">
                    <th className="text-left py-2 pr-4 font-medium text-dark-800 dark:text-white">{t('cookiesPage.tableCookie')}</th>
                    <th className="text-left py-2 pr-4 font-medium text-dark-800 dark:text-white">{t('cookiesPage.tablePurpose')}</th>
                    <th className="text-left py-2 font-medium text-dark-800 dark:text-white">{t('cookiesPage.tableDuration')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-100 dark:border-dark-700">
                    <td className="py-2 pr-4">__session</td>
                    <td className="py-2 pr-4">{t('cookiesPage.sessionPurpose')}</td>
                    <td className="py-2">{t('cookiesPage.sessionDuration')}</td>
                  </tr>
                  <tr className="border-b border-gray-100 dark:border-dark-700">
                    <td className="py-2 pr-4">i18next</td>
                    <td className="py-2 pr-4">{t('cookiesPage.i18nPurpose')}</td>
                    <td className="py-2">{t('cookiesPage.i18nDuration')}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className="text-lg font-medium text-dark-800 dark:text-white mt-6 mb-2">{t('cookiesPage.performanceTitle')}</h3>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.performanceText')}
            </p>
            <div className="overflow-x-auto mt-3">
              <table className="min-w-full text-sm text-gray-600 dark:text-gray-300">
                <thead>
                  <tr className="border-b border-gray-200 dark:border-dark-700">
                    <th className="text-left py-2 pr-4 font-medium text-dark-800 dark:text-white">{t('cookiesPage.tableCookie')}</th>
                    <th className="text-left py-2 pr-4 font-medium text-dark-800 dark:text-white">{t('cookiesPage.tablePurpose')}</th>
                    <th className="text-left py-2 font-medium text-dark-800 dark:text-white">{t('cookiesPage.tableDuration')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-100 dark:border-dark-700">
                    <td className="py-2 pr-4">_ga</td>
                    <td className="py-2 pr-4">{t('cookiesPage.gaPurpose')}</td>
                    <td className="py-2">{t('cookiesPage.gaDuration')}</td>
                  </tr>
                  <tr className="border-b border-gray-100 dark:border-dark-700">
                    <td className="py-2 pr-4">_ga_*</td>
                    <td className="py-2 pr-4">{t('cookiesPage.gaStarPurpose')}</td>
                    <td className="py-2">{t('cookiesPage.gaStarDuration')}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className="text-lg font-medium text-dark-800 dark:text-white mt-6 mb-2">{t('cookiesPage.functionalTitle')}</h3>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.functionalText')}
            </p>
            <div className="overflow-x-auto mt-3">
              <table className="min-w-full text-sm text-gray-600 dark:text-gray-300">
                <thead>
                  <tr className="border-b border-gray-200 dark:border-dark-700">
                    <th className="text-left py-2 pr-4 font-medium text-dark-800 dark:text-white">{t('cookiesPage.tableCookie')}</th>
                    <th className="text-left py-2 pr-4 font-medium text-dark-800 dark:text-white">{t('cookiesPage.tablePurpose')}</th>
                    <th className="text-left py-2 font-medium text-dark-800 dark:text-white">{t('cookiesPage.tableDuration')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-100 dark:border-dark-700">
                    <td className="py-2 pr-4">theme</td>
                    <td className="py-2 pr-4">{t('cookiesPage.themePurpose')}</td>
                    <td className="py-2">{t('cookiesPage.themeDuration')}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('cookiesPage.thirdPartyTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.thirdPartyDescription')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-3 space-y-2">
              <li><strong>{t('cookiesPage.thirdPartyItem1Label')}</strong> : {t('cookiesPage.thirdPartyItem1Text')}</li>
              <li><strong>{t('cookiesPage.thirdPartyItem2Label')}</strong> : {t('cookiesPage.thirdPartyItem2Text')}</li>
            </ul>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('cookiesPage.thirdPartyDisclaimer')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-2 space-y-1">
              <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-lime-600 hover:text-lime-700 underline">{t('cookiesPage.thirdPartyGooglePrivacy')}</a></li>
              <li><a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer" className="text-lime-600 hover:text-lime-700 underline">{t('cookiesPage.thirdPartyFirebasePrivacy')}</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('cookiesPage.pixelTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.pixelDescription')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-3 space-y-2">
              <li><strong>{t('cookiesPage.pixelItem1Label')}</strong> : {t('cookiesPage.pixelItem1Text')}</li>
              <li><strong>{t('cookiesPage.pixelItem2Label')}</strong> : {t('cookiesPage.pixelItem2Text')}</li>
            </ul>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('cookiesPage.pixelDisclaimer')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('cookiesPage.managementTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.managementDescription')}
            </p>

            <h3 className="text-lg font-medium text-dark-800 dark:text-white mt-4 mb-2">{t('cookiesPage.browserTitle')}</h3>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.browserText')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-2 space-y-1">
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-lime-600 hover:text-lime-700 underline">Google Chrome</a></li>
              <li><a href="https://support.mozilla.org/kb/enhanced-tracking-protection-firefox-desktop" target="_blank" rel="noopener noreferrer" className="text-lime-600 hover:text-lime-700 underline">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-lime-600 hover:text-lime-700 underline">Safari</a></li>
              <li><a href="https://support.microsoft.com/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-lime-600 hover:text-lime-700 underline">Microsoft Edge</a></li>
            </ul>

            <h3 className="text-lg font-medium text-dark-800 dark:text-white mt-4 mb-2">{t('cookiesPage.gaOptoutTitle')}</h3>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.gaOptoutText')}{' '}
              <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-lime-600 hover:text-lime-700 underline">{t('cookiesPage.gaOptoutLinkText')}</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('cookiesPage.consequencesTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.consequencesDescription')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-3 space-y-2">
              <li><strong>{t('cookiesPage.consequencesItem1Label')}</strong> : {t('cookiesPage.consequencesItem1Text')}</li>
              <li><strong>{t('cookiesPage.consequencesItem2Label')}</strong> : {t('cookiesPage.consequencesItem2Text')}</li>
              <li><strong>{t('cookiesPage.consequencesItem3Label')}</strong> : {t('cookiesPage.consequencesItem3Text')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('cookiesPage.retentionTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.retentionDescription')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-3 space-y-2">
              <li><strong>{t('cookiesPage.retentionItem1Label')}</strong> : {t('cookiesPage.retentionItem1Text')}</li>
              <li><strong>{t('cookiesPage.retentionItem2Label')}</strong> : {t('cookiesPage.retentionItem2Text')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('cookiesPage.changesTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.changesText')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('cookiesPage.contactTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.contactText')} <a href="mailto:contact@scalab-games.com" className="text-lime-600 hover:text-lime-700 underline">contact@scalab-games.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('cookiesPage.moreInfoTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookiesPage.moreInfoText')} <a href="https://www.cnil.fr/fr/cookies-et-autres-traceurs" target="_blank" rel="noopener noreferrer" className="text-lime-600 hover:text-lime-700 underline">www.cnil.fr/fr/cookies-et-autres-traceurs</a>
            </p>
          </section>
        </div>

        <p className="text-sm text-gray-500 dark:text-gray-400 mt-12">
          {t('cookiesPage.lastUpdated')}
        </p>
      </div>
    </PublicLayout>
  );
};

export default Cookies;
